import { DocumentSnapshot } from "store/firebase";
import "firebase/firestore";
import { Beer } from "./reducer";

export const beerFromDoc = (
  doc: DocumentSnapshot | null,
  imageUrl?: string | null
): Beer => {
  return {
    id: doc?.id ?? "no-id?",
    displayName: doc?.data()?.displayName ?? "",
    appearance: doc?.data()?.appearance ?? "",
    smell: doc?.data()?.smell ?? "",
    taste: doc?.data()?.taste ?? "",
    mouthfeel: doc?.data()?.mouthfeel ?? "",
    imageUrl: imageUrl ?? doc?.data()?.imageUrl ?? null,
  };
};

export const beerFromEventBeerName = (name: string | null): Beer => {
  return {
    id: beerIdFromName(name) ?? "",
    displayName: name ?? "",
    appearance: "",
    smell: "",
    taste: "",
    mouthfeel: "",
    imageUrl: null,
  };
};

export const beerIdFromName = (name: string | null): string | null => {
  if (!name) return null;
  return name
    .toLowerCase()
    .replace(/^-+|-+$/g, "")
    .replace(/\./g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .substring(0, 50);
};

export const sortBeers = (i1: Beer, i2: Beer): number => {
  return -1 * (i2?.displayName?.localeCompare(i1?.displayName ?? "") ?? 0);
};
